module.exports = __webpack_public_path__ + "static/media/LGSmartRegular__W.e45ecc4b.woff2";